import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import SaltyLogo from '../components/ui/SaltyLogo';

export default function LoginPage() {
  const { loginWithGoogle, isAuthenticated, error } = useAuth();
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left Panel */}
      <div className="w-full lg:w-1/2 flex items-center justify-center min-h-screen p-8">
        <div style={{ width: '100%', maxWidth: 360, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 24 }}>

          {/* Logo — grouped directly above the heading */}
          <img src="/salty-lockup.png" alt="Salty" style={{ height: 64, width: 'auto', flexShrink: 0 }} />

          <div>
            <h2 style={{ fontSize: 26, fontWeight: 700, color: '#0f172a', lineHeight: 1.2, marginBottom: 6 }}>
              Welcome back
            </h2>
            <p style={{ fontSize: 14, color: '#94a3b8', lineHeight: 1.6 }}>
              Sign in with your @salty.co.in Google account to continue.
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <GoogleLogin
              onSuccess={async (response) => {
                setLoading(true);
                await loginWithGoogle(response.credential);
                setLoading(false);
              }}
              onError={() => {}}
              text="signin_with"
              shape="rectangular"
              theme="outline"
              size="large"
              width="360"
            />

            {loading && (
              <p style={{ fontSize: 13, color: '#94a3b8' }}>Signing you in…</p>
            )}

            {error && (
              <div style={{ padding: '10px 14px', borderRadius: 10, background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', fontSize: 13 }} data-testid="error-message">
                {error}
              </div>
            )}

            <p style={{ fontSize: 11, color: '#cbd5e1' }}>
              Access is restricted to @salty.co.in accounts only.
            </p>
          </div>

        </div>
      </div>

      {/* Right Panel - Branded */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden" style={{ backgroundColor: '#0a0a0a' }}>
        {/* Dot grid */}
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, rgba(220,88,41,0.12) 1px, transparent 1px)',
          backgroundSize: '32px 32px',
        }} />
        {/* Orange glow */}
        <div className="absolute" style={{
          top: '15%', left: '25%', width: 380, height: 380,
          background: 'radial-gradient(circle, rgba(220,88,41,0.3) 0%, transparent 65%)',
          filter: 'blur(50px)',
        }} />

        <div className="relative z-10 flex flex-col justify-between p-14 w-full">
          <SaltyLogo height={30} variant="cream" showWordmark={true} />

          <div>
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#DC5829', marginBottom: 18 }}>
              CFO-grade intelligence
            </p>
            <h2 style={{ fontSize: 52, fontWeight: 700, lineHeight: 1.1, color: '#ffffff', marginBottom: 20 }}>
              Every rupee.<br />Every decision.<br />In one place.
            </h2>
            <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.4)', maxWidth: 300, lineHeight: 1.7 }}>
              Real-time AOP tracking, variance analysis, and scenario planning built for D2C operators.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
